import { lifecycle, compose } from 'recompose';
import type { NavigationSpec, NavigationState } from '../../states/NavigationState';
import { inject, MobXProviderContext } from 'mobx-react';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { useViewportState } from '../../../commonv3/hooks/useViewportState';
import { useContext, useEffect } from 'react';

export const withNavigation = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Props extends Record<string, unknown> = any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ContainerProps extends Record<string, unknown> = any
>(
  defaultSpec: NavigationSpec,
  mobileSpec?: NavigationSpec
) =>
  compose<Props & ContainerProps, ContainerProps>(
    inject('navigationState'),
    lifecycle<{ navigationState: NavigationState }, Record<string, unknown>>({
      componentDidMount() {
        const spec = mobileSpec ? (GlobalStatesV3.viewport.isDesktop ? defaultSpec : mobileSpec) : defaultSpec;
        this.props.navigationState.setSpec(spec);
      },
    })
  );

export const useNavigation = (defaultSpec: NavigationSpec, mobileSpec?: NavigationSpec) => {
  const { isDesktop } = useViewportState();
  const context = useContext(MobXProviderContext);
  useEffect(() => {
    const spec = mobileSpec ? (isDesktop ? defaultSpec : mobileSpec) : defaultSpec;
    if (spec) {
      context.navigationState.setSpec(spec);
    }
  }, [isDesktop, defaultSpec, mobileSpec]);
};
